"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "savoca": {
    "cf13666f": [{
      "hkey": "f54805e9",
      "slug": "savoca",
      "name": "Savoca",
      "primary": true,
      "skipSearch": false
    }],
    "barone": [{
      "hkey": "f54805e9",
      "slug": "savoca",
      "name": "Savoca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc5c6b60": [{
      "hkey": "9a6db0ca",
      "slug": "cantidati-scorsonello",
      "name": "Cantidati-Scorsonello",
      "primary": true,
      "skipSearch": false
    }],
    "cantidati": [{
      "hkey": "9a6db0ca",
      "slug": "cantidati-scorsonello",
      "name": "Cantidati-Scorsonello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7b7a2675": [{
      "hkey": "619d1b9f",
      "slug": "contura-superiore",
      "name": "Contura Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "contura": [{
      "hkey": "619d1b9f",
      "slug": "contura-superiore",
      "name": "Contura Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5dcb991f": [{
      "hkey": "f54805e9",
      "slug": "savoca",
      "name": "Savoca",
      "primary": true,
      "skipSearch": false
    }],
    "rapone": [{
      "hkey": "f54805e9",
      "slug": "savoca",
      "name": "Savoca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58fe29b3": [{
      "hkey": "f54805e9",
      "slug": "savoca",
      "name": "Savoca",
      "primary": true,
      "skipSearch": false
    }],
    "santa-domenica": [{
      "hkey": "f54805e9",
      "slug": "savoca",
      "name": "Savoca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed2e09c7": [{
      "hkey": "9a6db0ca",
      "slug": "cantidati-scorsonello",
      "name": "Cantidati-Scorsonello",
      "primary": true,
      "skipSearch": false
    }],
    "scorsonello": [{
      "hkey": "9a6db0ca",
      "slug": "cantidati-scorsonello",
      "name": "Cantidati-Scorsonello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "savoca"
    }]
  }
};
exports["default"] = _default;